import moment from 'moment'

export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorNumber = value => {
  if (Number(value) > 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorTIN = tin => {
  const tinRegex = /^\d{8}-\d{4}$/
  return tinRegex.test(tin)
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}
export const validatorUserID = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  const idRegex = /^[a-zA-Z]{6}-[0-9]{4}/
  return idRegex.test(val)
}

export const validatorMinimumFeeAmount = (value, { maxFee }) => {
  if (Number(value) <= Number(maxFee)) {
    return true
  }
  return false
}
export const validatorAmountLimit = (value, { maxFee }) => {
  if (Number(value) <= Number(maxFee)) {
    return true
  }
  return false
}
export const validatorAmountCheckLimit = (value, { maxFee }) => {
  if (Number(value) < Number(maxFee)) {
    return true
  }
  return false
}
export const validatorAccountLimit = (value, { maxFee }) => {
  if (Number(value) >= Number(maxFee)) {
    return true
  }
  return false
}
export const validatorMaxNum = (value, { maxNum }) => {
  if (Number(value) <= Number(maxNum)) {
    return true
  }
  return false
}
export const validatorMinNum = (value, { minNum }) => {
  if (Number(value) >= Number(minNum)) {
    return true
  }
  return false
}

export const validatorCardNumber = (value, { cardNumber }) => {
  if (Number(value) <= Number(cardNumber)) {
    return true
  }
  return false
}
export const validatorCardDeliveredAndReceived = (value, { cardDeliveredToDate, cardRequested }) => {
  const total = Number(cardDeliveredToDate) + Number(value)
  return total <= Number(cardRequested)
}

export const validatorMaxNumber = value => {
  if (value <= 100) {
    return true
  }
  return false
}
export const validatorMinNumber = value => {
  if (value >= 1) {
    return true
  }
  return false
}
export const validatorCustomMaxNumber = value => {
  if (value <= 200) {
    return true
  }
  return false
}
export const validatorMaxNumberValue = value => {
  if (value <= 5) {
    return true
  }
  return false
}

export const validatorTwoDecimalNumber = value => {
  // const regex = /^\d+\.\d{0,2}$/
  const regex = /^\d+\.\d{0,1}$/
  if (!regex.test(value)) {
    return true
  }
  return false
}

export const validatorMinimumPhoneNumber = value => {
  if (value.length < 7) {
    return true
  }
  return false
}
export const validatorMaximumPhoneNumber = value => {
  if (value.length > 11) {
    return true
  }
  return false
}
export const validatorDateLimit = (value, { minDate }) => {
  if (!value || !minDate) return false

  const inputDate = moment(value).startOf('day')
  const baseDate = moment(minDate).startOf('day')

  // Allow ONLY dates greater than the base date
  return inputDate.isAfter(baseDate)
}

//  Nigerian Mobile Network Operators and their prefixes
const NETWORK_PREFIXES = {
  // Airtel
  Airtel: [701, 708, 802, 808, 812, 901, 902, 907, 911, 912],

  // MTN
  MTN: [703, 706, 803, 806, 810, 813, 814, 816, 903, 906, 913, 916],

  // Glo
  Glo: [705, 805, 807, 811, 815, 905, 915],

  // 9mobile (formerly Etisalat)
  '9mobile': [704, 809, 817, 818, 908, 909],
}

const createNetworkMap = () => {
  const networkMap = {}

  Object.entries(NETWORK_PREFIXES).forEach(([network, prefixes]) => {
    prefixes.forEach(prefix => {
      networkMap[prefix] = network
    })
  })

  return networkMap
}

const NETWORK_MAP = createNetworkMap()

export const validateNigerianPhoneNumber = phoneNumber => {
  const result = {
    isValid: false,
    formatted: '',
    network: '',
    error: '',
    originalInput: phoneNumber || '',
  }

  // Input validation
  if (!phoneNumber) {
    result.error = 'Phone number is required'
    return result
  }

  if (typeof phoneNumber !== 'string') {
    result.error = 'Phone number must be a string'
    return result
  }

  // Clean the input - remove common formatting characters
  const cleanNumber = phoneNumber.replace(/[\s\-().]/g, '')

  // Validate that we only have digits after cleaning
  if (!/^\d+$/.test(cleanNumber)) {
    result.error = 'Phone number must contain digits only'
    return result
  }

  // Only accept 11-digit numbers starting with 0
  if (!cleanNumber.startsWith('0')) {
    result.error = 'Phone number must start with 0'
    return result
  }

  if (cleanNumber.length !== 11) {
    result.error = 'Phone number must be exactly 11 digits'
    return result
  }

  // Extract the 10-digit part after removing the leading 0
  const normalizedNumber = cleanNumber.substring(1)

  // Final validation of normalized number
  if (!/^\d{10}$/.test(normalizedNumber)) {
    result.error = 'Invalid phone number format'
    return result
  }

  // Extract and validate network prefix
  const prefix = Number.parseInt(normalizedNumber.substring(0, 3), 10)
  const network = NETWORK_MAP[prefix]

  if (!network) {
    result.error = `Invalid network prefix: ${0}${prefix}. This number does not belong to a recognized Nigerian mobile network`
    return result
  }

  // Success - populate result
  result.isValid = true
  result.formatted = cleanNumber // Keep the original 11-digit format with leading 0
  result.network = network

  return result
}

export const isValidNigerianPhoneNumber = phoneNumber => {
  const result = validateNigerianPhoneNumber(phoneNumber)
  return result.isValid
}

export const validateNigerianPhoneNumberStrict = phoneNumber => {
  const result = validateNigerianPhoneNumber(phoneNumber)
  if (!result.isValid) {
    throw new Error(result.error)
  }
  return true
}

export const formatNigerianPhoneNumber = phoneNumber => {
  const result = validateNigerianPhoneNumber(phoneNumber)
  return result.isValid ? result.formatted : null
}

export const getNigerianPhoneNetwork = phoneNumber => {
  const result = validateNigerianPhoneNumber(phoneNumber)
  return result.isValid ? result.network : null
}

export const getSupportedNetworks = () => ({ ...NETWORK_PREFIXES })

export const validatorUppercaseCharacter = value => {
  const strongRegex = new RegExp('^(?=.*[A-Z])')
  if (strongRegex.test(value)) {
    return true
  }
  return false
}
export const validatorLowerCaseCharacter = value => {
  const strongRegex = new RegExp('^(?=.*[a-z])')
  if (strongRegex.test(value)) {
    return true
  }
  return false
}
export const validatorNumerberOnly = value => {
  const strongRegex = new RegExp('^(?=.*[0-9])')
  if (strongRegex.test(value)) {
    return true
  }
  return false
}
export const validatorSpecialCharacter = value => {
  const strongRegex = new RegExp('^(?=.*[!@#$%&*()]).{8,}')
  if (strongRegex.test(value)) {
    return true
  }
  return false
}

export const validatorLimitedTwoDecimalNumbers = value => {
  const regex = /^\d+(\.\d{2})?$/
  if (regex.test(value)) {
    return true
  }
  return false
}
export const validatorUpToTwoDecimalNumbers = value => {
  // Convert to string to preserve trailing zeros
  const stringValue = String(value)
  const regex = /^\d+(\.\d{1,2})?$/
  return regex.test(stringValue)
}
export const validatorUpToThreeDecimalNumbers = value => {
  const regex = /^\d+(\.\d{1,3})?$/
  if (regex.test(value)) {
    return true
  }
  return false
}
export const validatorUpToFourDecimalNumbers = value => {
  const regex = /^\d+(\.\d{1,4})?$/
  if (regex.test(value)) {
    return true
  }
  return false
}

export const validatorDateDifference = (value, { maxDate }) => {
  if (moment(value) > moment(maxDate)) {
    return true
  }
  return false
}
export const validatorDateDifference2 = (value, { maxDate }) => {
  if (moment(value) >= moment(maxDate)) {
    return true
  }
  return false
}

export const isBusinessEmail = email => {
  const personalDomains = [
    'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'aol.com',
    'icloud.com', 'protonmail.com', 'zoho.com', 'mail.com', 'yandex.com',
  ]
  const domain = email.split('@')[1]?.toLowerCase()
  return domain && !personalDomains.includes(domain)
}

export const isValidEmail = email => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailPattern.test(email)
}

// export const validatorTwoDecimalNumbers = value => {
//   if (Number.isNaN(value)) { return false }
//   return 100 * value === parseInt(100 * value, 10)
// }

// toTwoDecimal() {
//   if (!this.fixedAssetRegisterFormData.originalBookValue) { return '0.00' }
//   return parseFloat(this.fixedAssetRegisterFormData.originalBookValue).toFixed(2)
// },
